export function withThemeInput<T extends Inputs>(inputs: T) {
  return [
    ...inputs,
    {
      name: "theme",
      friendlyName: "Component's theme",
      type: "string",
      enum: [
        { value: "inherit", label: "Inherit" },
        { value: "light", label: "Light" },
        { value: "dark", label: "Dark" },
      ],
      defaultValue: "inherit",
    },
  ] as const satisfies Inputs;
}
